import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=34e107f8&scoped=true&"
import script from "./MyDocuments.vue?vue&type=script&lang=js&"
export * from "./MyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=34e107f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e107f8",
  null
  
)

export default component.exports